import { InternalStepOption } from '@booking-booster-client/models';
import { step1 } from './step-1';

export const settingsAdvertisersDetail: InternalStepOption[] = [step1];
